
/** 业务类型 */
export const BusinessType = {
    /** 企业会员充值 */
    CORPORATE_MEMBER_RECHARGE: 'CORPORATE_MEMBER_RECHARGE'
};

/** 状态 */
export const Status = {
    /** 新建 */
    INIT: 'INIT',

    /** 已收款 */
    DOWN: 'DOWN'
};

/** 默认列表字段 */
export const DefaultListFeilds = {

    /** 收款单号 */
    id: 'receiptId',

    /** 企业名称 */
    companyName: 'payCompanyName',

    /** 交款总额（元） */
    totalAmount: 'payTotalAmount',

    /** 状态 */
    state: 'status',
    stateDesc: 'statusDesc',

    /** 业务类型 */
    businessType: 'businessType',
    businessTypeDesc: 'businessTypeDesc',

    /** 收款日期 */
    collectionTime: 'receiveDate',

};

/** 详情页面字段 */
export const DefaultDetailFields = {

    /** 操作 */
    operation: 'postStatusDescript',

    /** 操作备注 */
    operateRemark: 'comment',

    /** 操作人 */
    operator: 'auditUserName',

    /** 操作时间 */
    operateTime: 'gmtCreate'
};
